<template>
  <Modal v-model="model" :title="title" :width="width" :mask-closable="false" @on-visible-change="bindGetData">
    <Spin size="large" fix v-if="loading" />
    <!-- 预算 -->
    <Form v-if="type === 'budget'" inline :label-width="80" @submit.native.prevent>
      <FormItem label="预算">
        <RadioGroup v-model="mode" vertical @on-change="changeBudget">
          <Radio :label="0"><span>不限</span></Radio>
          <Radio :label="1">
            <InputNumber
              v-model="current"
              :min="50"
              :max="999999.99"
              :step="100"
              :precision="2"
              :disabled="!mode"
              :active-change="false"
              size="small"
              placeholder="请输入预算金额"
              style="width: 250px"
            />
          </Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <!-- 常规 -->
    <div v-else class="c-box">
      <Input v-model="keyword" search placeholder="请输入关键词" />
      <div class="c-content">
        <Row>
          <Col :span="colSpan">
            <div class="c-head">
              <span>{{ name }}列表</span>
              <span class="tag-title" v-show="type === 'retarget'">排除</span>
              <span class="tag-title" v-show="type === 'retarget'">定向</span>
              <span class="tag-title" v-show="type === 'retarget'">{{ attribe }}</span>
              <span class="tag-title" v-show="type === 'retarget'">ID</span>
              <span class="tag-title tag-title-a" v-show="type === 'pagespec'" @click="current = ''">清除</span>
            </div>
            <div class="c-body">
              <div v-if="!drops.length" class="no-data">
                <Icon type="ios-filing-outline" size="58" color="#efefef" />
                <span>暂无数据</span>
              </div>
              <template v-else-if="type === 'retarget'">
                <div v-for="item in drops" :key="item.id" class="c-check-item g-clearfix">
                  <span class="m-span">{{ item.name }}</span>
                  <span class="item-type" style="width: 70px">{{ item.id }}</span>
                  <span class="item-type">{{ attriVal(item) }}</span>
                  <RadioGroup v-model="item.select" style="width: 64px; float: right; line-height: 36px">
                    <Radio label="include" style="margin-right: 8px" :disabled="disCrowd"></Radio>
                    <Radio label="exclude" style="margin-right: 8px"></Radio>
                  </RadioGroup>
                  <span v-if="disCrowd" class="m-cataract c-include c-disabled"></span>
                  <span v-else class="m-cataract c-include" @click.stop="changeRetarget(item, 'include')"></span>
                  <span class="m-cataract c-exclude" @click.stop="changeRetarget(item, 'exclude')"></span>
                </div>
              </template>
              <RadioGroup v-model="current" vertical v-else-if="type === 'target'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.targetingName }}</Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'creative'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.ideaName }}</Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'pagespec'" class="c-item-radia-group" style="width: 100%">
                <template v-for="r in drops">
                  <Row :key="r.index">
                    <Col span="20"
                      ><Radio :label="r.index">{{ r.page_name }}</Radio></Col
                    >
                    <Col span="4" class="c-item-preview">
                      <a :href="r.preview_url" target="_blank" rel="noopener noreferrer"> 浏览 </a>
                      <a :href="r.preview_url" target="_blank" rel="noopener noreferrer">
                        <Icon type="md-document" color="#5489F2" size="20" />
                      </a>
                    </Col>
                  </Row>
                </template>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'convert'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">
                  {{ r.transFromTypeName }}
                </Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.name }}</Radio>
              </RadioGroup>
            </div>
          </Col>
          <Col span="8" v-if="type === 'retarget'">
            <div class="m-box c-result-box">
              <span class="c-retarget-clear" @click="$emit('on-clear', { type })">清空全部</span>
              <Tabs v-model="currenTab" size="small">
                <TabPane :label="`定向${includes.length ? '(' + includes.length + ')' : ''}`" class="c-retarget-result" name="include">
                  <div v-for="item in includes" :key="item.id" class="c-pop-tip">
                    <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                  </div>
                </TabPane>
                <TabPane :label="`排除${excludes.length ? '(' + excludes.length + ')' : ''}`" class="c-retarget-result" name="exclude">
                  <div v-for="item in excludes" :key="item.id" class="c-pop-tip">
                    <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { isArray, isEmpty, deepCopy } from '@/common/js/utils'
import { toCountCrowd } from '@/common/js/filters'
export default {
  name: 'setBatch',
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    type: {
      type: String
    },
    data: {
      type: [Array, Object]
    },
    media: {
      type: [Number, String]
    },
    disCrowd: {
      type: Boolean
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    drops() {
      if (isArray(this.data)) {
        const drops = this.data
          .filter((ret) => {
            const keyword = String(this.keyword)
            if (keyword && this.type === 'target') return ret.targetingName.includes(keyword)
            else if (keyword && this.type === 'creative') return ret.ideaName.includes(keyword)
            else if (keyword && this.type === 'pagespec') return ret.page_name.includes(keyword)
            else if (keyword && this.type === 'convert') return true
            else if (keyword) return ret.name.includes(keyword)
            else {
              return true
            }
          })
          .map((met, i) => {
            return Object.assign(met, { index: i })
          })
        return drops
      } else return []
    },
    includes() {
      if (!isArray(this.drops)) return []
      return this.drops.filter((ret) => ret.select === 'include')
    },
    excludes() {
      if (!isArray(this.drops)) return []
      return this.drops.filter((ret) => ret.select === 'exclude')
    },
    title() {
      return `请选择${this.name}`
    },
    name() {
      let name = ''
      switch (this.type) {
        case 'account':
          name = '计划账号'
          break
        case 'campaign':
          name = '计划组'
          break
        case 'target':
          name = '定向包'
          break
        case 'retarget':
          name = '人群包'
          break
        case 'creative':
          name = '创意组'
          break
        case 'convert':
          name = '转化追踪类型'
          break
        case 'pagespec':
          name = '落地页'
          break
      }
      return name
    },
    attribe() {
      if (this.media === 16) return '覆盖数量'
      else return '属性'
    },
    attriVal() {
      return (item) => {
        if (this.media === 16) return toCountCrowd(item.count)
        else if (this.media === 45) return item.source
        else return '未知'
      }
    }
  },
  data() {
    return {
      keyword: '',
      current: '',
      mode: '', // 预算模式
      currenTab: 'include',
      colSpan: 24,
      width: 620
    }
  },
  methods: {
    bindGetData(val) {
      if (this.type === 'retarget') {
        this.currenTab = 'include'
        this.colSpan = 16
        this.width = 720
      } else {
        this.colSpan = 24
        this.width = 620
      }
      if (val) {
        this.keyword = ''
        if (this.type === 'budget') {
          const data = deepCopy(this.data)
          const { value, mode } = data.pop()
          this.current = value
          this.mode = mode
        } else if (this.type === 'pagespec') {
          const pages = this.data.filter((ret) => ret.check).pop()
          this.current = pages ? pages.index : ''
          this.mode = ''
        } else if (this.type === 'convert') {
          const index = this.data.findIndex((ret) => ret.check)
          this.current = index > -1 ? index : ''
          this.mode = ''
        } else {
          this.current = ''
          this.mode = ''
        }
      }
    },
    changeBudget(val) {
      if (val) this.current = 50
    },
    changeRetarget(item, type) {
      const check = item.select
      if (type === check) this.$set(item, 'select', null)
      else this.$set(item, 'select', type)
    },
    handleClose(e, name) {
      this.$emit('on-delete', { type: this.type, name })
    },
    ok() {
      const retarget = this.drops.some((ret) => {
        return ret.select === 'include' || ret.select === 'exclude'
      })
      if (this.type === 'retarget') {
        if (!retarget) {
          this.$Modal.confirm({
            title: '系统提示',
            content: `<p>您还未选择${this.name}，该操作将清除原已配置的人群包，确认该操作吗？</p>`,
            onOk: () => {
              this.submit(0)
            }
          })
        } else this.submit(0)
      } else if (this.type === 'budget') {
        if (this.mode === 'BUDGET' && !this.current) {
          this.$Message.error('预算范围 100-100,000,000元')
          return
        }
        this.submit({ value: this.current, mode: this.mode })
      } else if (this.type === 'bid') {
        const err = []
        if (this.data.bid_range) {
          // 随机定价
          const [min, max] = this.data.bid_num_range
          if (isEmpty(min) || isEmpty(max)) err.push({ feild: '目标转化出价', msg: '随机目标转化出价不能为空' })
          else if (
            this.data.pricing === 'PRICING_OCPM' &&
            !(this.data.smart_bid_type === 'SMART_BID_CONSERVATIVE' && this.data.adjust_cpa === 0) &&
            (min < 0.1 || max > 10000)
          ) {
            err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
          } else if (this.data.pricing === 'PRICING_CPC' && (min < 0.2 || max > 100)) {
            err.push({ feild: '点击出价', msg: '出价范围：0.2~100（元）' })
          } else if (this.data.pricing === 'PRICING_CPM' && (min < 4 || max > 100)) {
            err.push({ feild: '展示出价', msg: '出价范围：4~100（元）' })
          }
          if (max > this.data.budget) err.push({ feild: '转化出价', msg: '随机出价不能大于预算值' })
        } else {
          // 出价设置
          const bid = this.data.bid
          const cpa_bid = this.data.cpa_bid
          if (
            this.data.pricing === 'PRICING_OCPM' &&
            !(this.data.smart_bid_type === 'SMART_BID_CONSERVATIVE' && this.data.adjust_cpa === 0) &&
            !(cpa_bid >= 0.1 && cpa_bid <= 10000)
          ) {
            err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
          } else if (this.data.pricing === 'PRICING_CPC' && !(bid >= 0.2 && bid <= 100)) {
            err.push({ feild: '点击出价', msg: '出价范围：0.2~100（元）' })
          } else if (this.data.pricing === 'PRICING_CPM' && !(bid >= 4 && bid <= 100)) {
            err.push({ feild: '展示出价', msg: '出价范围：4~100（元）' })
          }
          if (cpa_bid > this.data.budget) err.push({ feild: '转化出价', msg: '不能大于预算值' })
        }
        if (this.data.deep_cpabid_range) {
          const [min, max] = this.data.deep_cpabid_num_range
          if (isEmpty(min) || isEmpty(max)) err.push({ feild: '深度转化出价', msg: '随机深度转化出价不能为空' })
        } else if (this.data.deep_bid_type === 'ROI_COEFFICIENT') {
          if (isEmpty(this.data.roi_goal)) err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空' })
          else {
            const roi = Number(this.data.roi_goal)
            const min = 0
            const max = 5
            if (roi <= min || roi > max) err.push({ feild: 'ROI系数', msg: `ROI系数应大于${min}，小于等于${max}` })
          }
        } else {
          // 深度优化出价
          if (
            (this.data.deep_bid_type === 'DEEP_BID_MIN' || this.data.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') &&
            isEmpty(this.data.deep_cpabid)
          ) {
            err.push({ feild: '深度优化出价', msg: '深度转化出价不能为空' })
          }
        }

        if (err.length) {
          const shift = err.shift()
          this.$Message.error(`${shift.feild}${shift.msg}`)
          // 如果错误中断
          return
        }
        this.submit(this.data)
      } else {
        if (typeof this.current !== 'number') {
          this.$Message.error(`您还未选择${this.name}`)
          return
        }
        this.submit(this.current)
      }
    },
    submit(index) {
      this.$emit('on-select', { type: this.type, index })
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-box {
  position: relative;

  .c-content {
    margin-top: 12px;
    border: solid 1px #dee4f5;
    border-radius: 3px;
    font-size: 14px;

    .c-head {
      line-height: 32px;
      background-color: #fafbfe;
      padding-left: 12px;
      border-bottom: solid 1px #dee4f5;

      .tag-title {
        float: right;
        font-size: 12px;
        margin-right: 14px;
      }

      .tag-title-a {
        color: #5489f2;
        cursor: pointer;
      }
    }

    .c-body {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      max-height: 365px;
      min-height: 120px;

      .ivu-radio-wrapper {
        font-size: 13px;

        ::v-deep .ivu-radio {
          margin-right: 8px;
        }
      }

      .no-data {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        span {
          color: #c1c1c1;
        }
      }

      .c-item-radia-group {
        padding: 8px 0 8px 12px;
      }

      .c-item-preview {
        display: flex;
        align-items: center;
        justify-content: center;

        a {
          padding: 0 4px;

          &:first-child {
            line-height: 30px;
          }

          &:last-child {
            line-height: 1.2;
          }

          &.del-profile {
            display: none;
            line-height: 30px;
          }
        }
      }

      .c-check-item {
        margin: 0;
        padding-left: 12px;
        display: flex;
        position: relative;
        align-items: center;
        height: 36px;
        width: 100%;

        &:hover {
          background-color: #f8f8f8;
        }

        .m-span {
          width: calc(100% - 190px);
          display: inline-block;
          line-height: 1;
        }

        .item-type {
          text-align: right;
          display: inline-block;
          width: 60px;
          padding-right: 10px;
          font-size: 12px;
        }

        .ivu-radio-group {
          width: 70px !important;
        }

        .ivu-radio-wrapper {
          min-width: inherit;
          text-align: right;
          font-size: 0;
          margin-right: 14px;
        }

        .m-cataract {
          position: absolute;
          width: 18px;
          height: 36px;
          cursor: pointer;
          user-select: none;
          top: 0;

          &.c-disabled {
            cursor: not-allowed;
          }
        }

        .c-include {
          right: 46px;
        }

        .c-exclude {
          right: 16px;
        }
      }
    }

    .c-result-box {
      position: relative;

      ::v-deep.ivu-tabs-bar {
        background-color: #fafbfe;
        margin-bottom: 0;
      }

      .c-retarget-clear {
        width: 60px;
        height: 34px;
        line-height: 34px;
        position: absolute;
        z-index: 8;
        right: 0;
        top: 0;
        display: block;
        color: #598fe6;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
      }

      .c-retarget-result {
        overflow-y: auto;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;
        height: 365px;
        padding-bottom: 8px;

        .c-tag-item {
          margin: 8px 12px 0;
          padding: 2px 6px;
          display: block;
          height: 28px;

          ::v-deep .ivu-tag-text {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 88%;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

.ivu-form-inline .ivu-form-item {
  display: block;
}

::v-deep .row-item {
  align-items: flex-start;

  .item-field {
    line-height: 32px;
  }
}

::v-deep .upload-image {
  width: 1000%;
  overflow: hidden;

  .c-wrap {
    width: 100%;
    max-width: 340px;

    .c-complete {
      width: 150px;
      height: 100px;
      background-color: #efefef;

      img {
        border-radius: 4px;
      }

      .m-image-box {
        width: 150px;
        height: 100px;
      }
    }

    .c-init {
      width: 100px;
      height: 100px;
      cursor: pointer;
      border-style: dashed;
      border-width: 1px;
      border-color: #4b77ee;
      border-radius: 4px;
      text-align: center;

      i,
      span {
        color: #4b77ee;
      }

      .min-column {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        width: 100px;
        height: 100px;
        margin: 0 auto;

        span {
          display: inline-block;
          width: 30px;
        }
      }
    }

    ::v-deep.ivu-upload-select {
      width: 100%;
      height: 100%;
      cursor: pointer;
      user-select: none;
    }
  }

  .c-message {
    line-height: 1.2;
    margin-top: 12px;

    i {
      display: inline-block;
    }

    .c-info {
      margin-left: 5px;
    }
  }
}
</style>
